import cn from 'clsx'
import { rem } from 'polished'
import React from 'react'
import styled, { css } from 'styled-components'
import { tierGradientBackgroundStyle, tierNormalContrastColorStyle } from 'styles/utils/tierStyles'

const StyledCard = styled.div<{ $rounded?: boolean }>`
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  overflow: hidden;
  ${props => props.$rounded && `border-radius: ${rem(8)};`}
`

const StyledHeader = styled.div<{ $padding: string; $row?: boolean }>`
  padding: ${props => props.$padding};
  ${props => props.$row && css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${rem(12)};
  `}
  ${tierGradientBackgroundStyle}
  ${tierNormalContrastColorStyle}
`

const StyledBody = styled.div<{ $padding: string; $gap: number }>`
  padding: ${props => props.$padding};
  gap: ${props => rem(props.$gap)};
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
  display: flex;
  flex-direction: column;
`

interface CardProps {
  children: React.ReactNode
  rounded?: boolean
  className?: string
}

interface HeaderProps {
  children: React.ReactNode
  tier: App.LoyaltyTier
  padding?: string
  row?: boolean
  className?: string
}

interface BodyProps {
  children: React.ReactNode
  padding?: string
  gap?: number
  className?: string
}

export function LoyaltyTierCard({ children, rounded, className }: CardProps) {
  return <StyledCard $rounded={rounded} className={className}>{children}</StyledCard>
}

export function LoyaltyTierCardHeader({ children, tier, padding = `${rem(16)} ${rem(20)}`, row, className }: HeaderProps) {
  return <StyledHeader $padding={padding} $row={row} className={cn(`tier-${tier}`, className)}>{children}</StyledHeader>
}

export function LoyaltyTierCardBody({ children, padding = `${rem(16)} ${rem(24)}`, gap = 8, className }: BodyProps) {
  return <StyledBody $padding={padding} $gap={gap} className={className}>{children}</StyledBody>
}
